import { render } from "./ClassesCard.vue?vue&type=template&id=0c12ddca&scoped=true"
import script from "./ClassesCard.vue?vue&type=script&lang=js"
export * from "./ClassesCard.vue?vue&type=script&lang=js"

import "./ClassesCard.vue?vue&type=style&index=0&id=0c12ddca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c12ddca"]])

export default __exports__